import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateSupplierActions } from "store/ducks/settings/suppliers";

export function* updateSupplierRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/supplier/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateSupplierActions.success(data));
    notify("success", "Fornecedor atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateSupplierActions.failure(errorMessage));
  }
}
